<template>
  <table class="table table-bordered">
    <thead>
      <tr>
        <th style="min-width: 420px">Plano de contas</th>
        <th v-for="item in report.balance" :key="item">
          {{ item.period }}
        </th>
      </tr>
    </thead>

    <tbody
      v-for="(rootAccount, rootIndex) in report.chartOfAccounts"
      :key="rootAccount.id"
    >
      <PlanAccountRow
        :account="rootAccount"
        :isLast="rootIndex == report.chartOfAccounts.length - 1"
        :style="{ backgroundColor: rootIndex % 2 === 0 ? '#fff' : '#f3f6f9' }"
      />
      <PlanAccountRow
        v-for="(childAccount, childIndex) in rootAccount.children"
        :key="childAccount.id"
        :account="childAccount"
        :isChild="true"
        :isLast="childIndex == rootAccount.children.length - 1"
        :style="{ backgroundColor: rootIndex % 2 === 0 ? '#fff' : '#f3f6f9' }"
      />
    </tbody>
  </table>
</template>

<script>
import PlanAccountRow from "./PlanAccountRow.vue";

export default {
  name: "PlanAccountTable",
  components: {
    PlanAccountRow,
  },
  props: {
    report: {
      type: Object,
      required: true,
    },
  },
};
</script>
